<template>
	<div v-if="params.nameFields">
		<div class="info-holder">
			<div class="info-content" v-for="field in params.nameFields" :key="field">{{value[field]}}</div>
		</div>
	</div>
	<div class="address-holder" v-else>
		<div class="info-holder">
			<label class="info-title" v-if="value.nation">国家地区</label>
			<div class="info-content" v-if="value.nation">{{value.nation.name}}</div>
			<!-- <label class="info-title">省市</label>
			<div class="info-content">{{value.province | fieldShowRegion}}</div>-->
			<label class="info-title">联系人</label>
			<div class="info-content">{{value.name}}</div>
			<label class="info-title">电话</label>
			<div class="info-content">{{value.phone}}</div>
		</div>
		<div class="info-holder">
			<label class="info-title">详细地址</label>
			<div class="info-content">{{value.street}}</div>
		</div>
	</div>
</template>

<script>
import FieldShowRegion from "@/components/Fields/FieldShowRegion";
import Field_relate_simple_id from "@/components/Fields/Field_relate_simple_id";

export default {
	filters: [FieldShowRegion, Field_relate_simple_id],
	data() {
		return {
			loadings: {
				main: false,
			},
			info: {},
			styles: [],
			visible: false,
			everEdited: false,
			hasGetData: false,
		};
	},
	props: {
		fieldInfo: {
			type: Object,
		},
		value: [Object, String, Number, Array, Boolean],
		recordModel: {
			type: String,
			default: "",
		},
		params: {
			type: Object,
			default: () => {
				return {
					nameFields: [],
				};
			},
		},
	},
	mounted() {},
	methods: {},
};
</script>
<style lang="scss" scoped>
.address-holder {
	background: #f0f0f0;
	padding: 1em;
}
.info-holder {
	display: flex;
	.info-title {
		padding-right: 1em;
		font-weight: 500;
	}
	.info-content {
		padding-right: 2em;
	}
}
</style>
